import { IFacility } from './../../models/facility';
import { ISearchFacilityGroup, FacilityState } from './../../models/search';
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IGeneralData } from '../../models/general.model';

export enum ActionTypes {
  ADD_FACILITY = '[App] Get Facilities',
  ADD_ROOM_FACILITY = '[App] t',
  ADD_EXTRA_FACILITIES = '[App] fsd'
}

export class AddFacilityAction implements Action {
  readonly type = ActionTypes.ADD_FACILITY;
  constructor (public payload: {facilities: ISearchFacilityGroup[]}) {}
}

export class AddRoomFacilityAction implements Action {
  readonly type = ActionTypes.ADD_ROOM_FACILITY;
  constructor (public payload: {facilities: ISearchFacilityGroup[]}) {}
}

export class AddExtraFacilityAction implements Action {
  readonly type = ActionTypes.ADD_EXTRA_FACILITIES;
  constructor (public payload: {facilities: ISearchFacilityGroup}) {}
}



export type Actions = AddFacilityAction | AddRoomFacilityAction | AddExtraFacilityAction;
